import React, { useMemo } from "react";
import { getVal, setVal } from "oolib";

import { useMetricCardConfig } from "./ConfigForm_Context";
import { ConfigForm_SectionWrapper } from "./ConfigForm_SectionWrapper";
import { DataFieldInputSelector } from "@/components/DataFieldInputSelector";

const DISPLAY_MODE_OPTIONS = [
  { display: "Count", value: "countOnly" },
  { display: "Percentage", value: "percentageOnly" },
  { display: "Count, Percentage", value: "countAndPercentage" }
];

export const ConfigForm_DisplaySection = () => {
  const {
    widgetConfig,
    updateWidget,
    dataKeys,
    measureMode
  } = useMetricCardConfig();

  const selectedField = getVal(widgetConfig, dataKeys.field);
  const isNumberInput = selectedField?.comp === 'NumberInput';
  const currentMode = getVal(widgetConfig, dataKeys.displayMode) || 'countAndPercentage';

  const displayValue = useMemo(() => {
    const match = DISPLAY_MODE_OPTIONS.find(opt => opt.value === currentMode);
    if (!match) return null;
    return { ...match, dataType: "Stats to Show" };
  }, [currentMode]);

  return (
    <ConfigForm_SectionWrapper icon="Eye" title="Display">
      <DataFieldInputSelector
        id={dataKeys.displayMode}
        options={DISPLAY_MODE_OPTIONS}
        value={displayValue}
        onChange={(id, v) => {
          updateWidget(w => setVal(w, dataKeys.displayMode, v.value));
        }}
        placeholder="Select display mode"
        placeholderIcon="Eye"
        trailingIcon="CaretRight"
        tooltip={{ text: "Choose what stats to display", placement: "top" }}
        hideSearchHeader
      />
    </ConfigForm_SectionWrapper>
  );
};
